import { LABEL_INSET } from '../comparisonBar/layout';
import type { ComparisonWaterfallLayout } from './types';

/** A single total or delta category band. */
const ROW_HEIGHT = 48;
const GRID_TOP = 8;
const GRID_BOTTOM = 40;
const GRID_RIGHT = 96;
const LABEL_GUTTER = LABEL_INSET / 2;

export const buildComparisonWaterfallLayout = (rowCount: number, labelWidthPx: number): ComparisonWaterfallLayout => ({
  rowHeight: ROW_HEIGHT,
  gridTop: GRID_TOP,
  gridHeight: Math.max(ROW_HEIGHT, rowCount * ROW_HEIGHT),
  gridBottom: GRID_BOTTOM,
  gridLeft: labelWidthPx,
  gridRight: GRID_RIGHT,
  labelWidth: Math.max(0, labelWidthPx - LABEL_INSET),
  labelMargin: labelWidthPx - LABEL_GUTTER,
});
